"use strict";

var _lodash = require("lodash");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var NEW_USER_FORM = {
  title: 'Add a new member',
  saveLabel: 'Add',
  fields: {
    id: {
      order: 1,
      kind: 'email',
      label: 'Email'
    },
    role: {
      order: 2,
      kind: 'choice',
      kind_options: {
        values: {
          guest: 'Guest (only has access to the workspaces)',
          member: 'Member (can see other members)',
          organizer: 'Organizer (can see other members, create and join workspaces)',
          admin: 'Administrator (can create workspaces and promote other members)'
        }
      },
      default: 'guest'
    }
  }
};
var OrgMemberList = /*#__PURE__*/function () {
  OrgMemberList.$inject = ["$rootScope", "$route", "$location", "$log", "$scope", "orgService", "eventService", "modalService", "userService"];
  /* @ngInject */
  function OrgMemberList($rootScope, $route, $location, $log, $scope, orgService, eventService, modalService, userService) {
    _classCallCheck(this, OrgMemberList);
    this.$rootScope = $rootScope;
    this.$route = $route;
    this.$location = $location;
    this.$log = $log;
    this.orgService = orgService;
    this.eventService = eventService;
    this.modalService = modalService;
    this.userService = userService;
    this.currentUser = userService.getCurrentUser();
    this.roles = ['admin', 'member', 'organizer', 'guest'];
    this.userCanSeeEmails = userService.matchesRoles({
      globalRole: 'superadmin'
    }, {
      globalRole: 'spotme_support'
    });
    this.canToggleUserRole = this.userService.hasPermission('global_actions.toggle_role');
    this.canRemoveHimselfFromOrg = this.userService.hasPermission('org_realms.remove_yourself_from_org');
    this.setFlashMessage = function (message, level) {
      return $rootScope.setFlashMessage(message, level);
    };
    this.loading = true;
    this.searchQuery = '';
    this.$scope = $scope;
    this.originalMembers = [];
    this.members = [];
    this.rolesOptions = this.roles.map(function (role) {
      return {
        id: role,
        text: role.charAt(0).toUpperCase() + role.slice(1)
      };
    });
  }
  _createClass(OrgMemberList, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.$scope.$watch('$ctrl.searchQuery', function (searchQuery) {
        if (searchQuery !== null && searchQuery !== void 0 && searchQuery.length) {
          _this.visibleMembers = _this.members.filter(function (member) {
            var search = member.realname;
            if (_this.userCanSeeEmails) {
              search = "".concat(search, " ").concat(member.email);
            }
            search = search.toLocaleLowerCase();
            var query = _this.searchQuery.toLocaleLowerCase();
            return search.includes(query);
          });
        } else {
          _this.visibleMembers = _this.members;
        }
      });
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this2 = this;
      if (changes.organisation && this.organisation) {
        this.orgId = this.organisation.name;
        this.loading = true;
        this.orgService.getAllOrgMemberUsers(this.organisation.name).then(function (_ref) {
          var data = _ref.data;
          data.forEach(function (member) {
            var _this2$getMemberRole;
            return member._role = (_this2$getMemberRole = _this2.getMemberRole(member)) === null || _this2$getMemberRole === void 0 ? void 0 : _this2$getMemberRole.id;
          });
          _this2.originalMembers = (0, _lodash.cloneDeep)(data);
          _this2.members = data;
          _this2.visibleMembers = _this2.members;
        }, function () {
          return alert('Failed to fetch member list');
        }).finally(function () {
          return _this2.loading = false;
        });
      }
    }
  }, {
    key: "canSetOrgMemberRole",
    value: function canSetOrgMemberRole() {
      return this.userService.hasPermission('access_modification_realms.set_org_member_role', {
        org_id: this.organisation._id
      });
    }

    /* create new users */
  }, {
    key: "canCreateMembers",
    value: function canCreateMembers() {
      return this.userService.hasPermission('global_actions.create_user', {
        org_id: this.organisation._id
      }) || this.canSetOrgMemberRole();
    }
  }, {
    key: "showNewUserModal",
    value: function showNewUserModal() {
      var _this3 = this;
      this.modalService.openModalWithForm(NEW_USER_FORM).then(function (model) {
        return _this3.addOrSetMemberRelation(model);
      });
    }
  }, {
    key: "addOrSetMemberRelation",
    value: function addOrSetMemberRelation(descriptor, form) {
      var _this4 = this;
      var promise, userEmail;
      if (form && form.$invalid || !(descriptor && descriptor.id)) return;
      userEmail = descriptor.id;
      promise = this.orgService.addOrgUserPermission(this.orgId, userEmail, descriptor.role);
      promise.then(function () {
        _this4.setFlashMessage("A new relation was established in ".concat(_this4.orgId, "."));
        return _this4.$route.reload();
      }, function () {
        // user doesn't exist, create it
        // redirect to the to-be-primed user creation form
        _this4.$rootScope.setNavigationWarningMessage(null);
        _this4.$location.search('org', _this4.organisation._id);
        _this4.$location.search('email', userEmail);
        _this4.$location.search('orgRole', descriptor.role);
        _this4.$location.path('/users/new');
        return;
      });
    }
    /* --- */

    /* promote or demote users */
  }, {
    key: "canPromoteMember",
    value: function canPromoteMember(member) {
      return this.canSetOrgMemberRole() && !this.memberHasRole(member, 'admin');
    }
  }, {
    key: "canDemoteMember",
    value: function canDemoteMember(member) {
      return this.canSetOrgMemberRole() && this.memberHasRole(member, 'admin') && member._id !== this.currentUser._id;
    }
  }, {
    key: "memberHasRole",
    value: function memberHasRole(member, role) {
      return member.roles.some(function (membersRole) {
        return membersRole.role === role;
      });
    }
  }, {
    key: "getMemberRole",
    value: function getMemberRole(member) {
      var _this5 = this;
      var orgRoleObj = member.roles.find(function (membersRole) {
        return _this5.roles.includes(membersRole.role);
      });
      return this.rolesOptions.find(function (role) {
        return role.id === (orgRoleObj === null || orgRoleObj === void 0 ? void 0 : orgRoleObj.role);
      });
    }
  }, {
    key: "memberHasRolePermissions",
    value: function memberHasRolePermissions(member, role) {
      return member.roles.some(function (membersRole) {
        return membersRole.role === role;
      }) || this.isRoleInheritedFromOrgRole(member, role);
    }
  }, {
    key: "isRoleInheritedFromOrgRole",
    value: function isRoleInheritedFromOrgRole(member, role) {
      var _this6 = this;
      var orgRoleObj = member.roles.find(function (membersRole) {
        return _this6.roles.includes(membersRole.role);
      });
      var inheritedRoleObj = {
        type: 'account_permission',
        role: role,
        org_id: this.organisation._id
      };
      return this.userService.canAssignRole([orgRoleObj], inheritedRoleObj);
    }
  }, {
    key: "confirmAndPromoteUser",
    value: function confirmAndPromoteUser(member, role) {
      var _this7 = this;
      var username = member.name;
      this.modalService.openConfirm({
        message: "You are changing the role of ".concat(username, " to ").concat(role, ". Are you sure?"),
        okLabel: 'Continue'
      }).then(function () {
        return _this7.addOrSetMemberRelation({
          id: username,
          role: role
        });
      }).catch(function () {
        return member._role = _this7.originalMembers.find(function (m) {
          return m._id === member._id;
        })._role;
      });
    }
  }, {
    key: "getRemoveRoleTitle",
    value: function getRemoveRoleTitle(member, role) {
      return this.isRoleInheritedFromOrgRole(member, role) ? 'This role cannot be removed as it is inherited.' : 'Remove role';
    }
    /* --- */

    /* remove org member */
  }, {
    key: "removeOrgMember",
    value: function removeOrgMember(member) {
      return member._id !== this.currentUser._id && this.userService.hasPermission('org_realms.remove_org_member', {
        org_id: this.organisation._id
      });
    }
  }, {
    key: "canRemoveMember",
    value: function canRemoveMember(member) {
      return this.canRemoveHimselfFromOrg || this.removeOrgMember(member);
    }
  }, {
    key: "confirmAndRemoveUser",
    value: function () {
      var _confirmAndRemoveUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(member) {
        var orgName, memberName, message;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              orgName = this.organisation.display_name;
              memberName = member.realname;
              message = "You are about to remove ".concat(memberName, " from ").concat(orgName, ". It will also revoke access to all workspaces in ").concat(orgName, ".");
              _context.prev = 3;
              _context.next = 6;
              return this.modalService.openConfirm({
                message: message,
                okLabel: 'Remove user'
              });
            case 6:
              return _context.abrupt("return", this.removeUser(member));
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 9]]);
      }));
      function confirmAndRemoveUser(_x) {
        return _confirmAndRemoveUser.apply(this, arguments);
      }
      return confirmAndRemoveUser;
    }()
  }, {
    key: "removeUser",
    value: function () {
      var _removeUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(member) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.orgService.removeMember(this.orgId, member._id);
            case 3:
              this.setFlashMessage("".concat(member.realname, " was removed from ").concat(this.organisation.display_name));
              this.$route.reload();
              _context2.next = 11;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              this.setFlashMessage('An error occurred while removing member', 'danger');
              console.error('Error while removing member', _context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function removeUser(_x2) {
        return _removeUser.apply(this, arguments);
      }
      return removeUser;
    }()
    /* --- */
    /* mfa phone clearing */
  }, {
    key: "canClearPhone",
    value: function canClearPhone(member) {
      return this.removeOrgMember(member);
    }
  }, {
    key: "showClearPhoneModal",
    value: function () {
      var _showClearPhoneModal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(member) {
        var message, title;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              message = 'Are you sure you want to remove this user\'s phone number? He or she will be informed of this change via email.';
              title = 'Remove this users\'s phone number';
              _context3.prev = 2;
              _context3.next = 5;
              return this.modalService.openConfirm({
                title: title,
                message: message,
                okLabel: 'Remove',
                buttonClass: 'danger'
              });
            case 5:
              return _context3.abrupt("return", this.clearPhone(member));
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](2);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 8]]);
      }));
      function showClearPhoneModal(_x3) {
        return _showClearPhoneModal.apply(this, arguments);
      }
      return showClearPhoneModal;
    }()
  }, {
    key: "clearPhone",
    value: function () {
      var _clearPhone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(member) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.orgService.clearPhone(this.orgId, member._id);
            case 3:
              this.setFlashMessage("".concat(member.realname, "'s phone number was removed from their profile"));
              _context4.next = 10;
              break;
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              this.setFlashMessage('An error occurred while removing the phone number', 'danger');
              console.error('Error while removing phone member', _context4.t0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 6]]);
      }));
      function clearPhone(_x4) {
        return _clearPhone.apply(this, arguments);
      }
      return clearPhone;
    }() /* toggle user role */
  }, {
    key: "toggleUserRole",
    value: function toggleUserRole(username, role) {
      var _this8 = this;
      return this.orgService.toggleOrgUserPermission(this.orgId, username, role).then(function () {
        _this8.setFlashMessage("A new relation was established in ".concat(_this8.orgId, "."));
        return _this8.$route.reload();
      }).catch(function (err) {
        alert('An error occurred. Are you sure the target item exists?');
        return _this8.$log.error('Error while adding the relation', err);
      });
    }
  }, {
    key: "confirmAndToggleUsersRole",
    value: function confirmAndToggleUsersRole(member, role) {
      var _this9 = this;
      if (this.isRoleInheritedFromOrgRole(member, role)) return;
      var message = this.memberHasRole(member, role) ? "You are removing the ".concat(role, " role from ").concat(member.name, ". Are you sure?") : "You are adding the ".concat(role, " role to ").concat(member.name, ". Are you sure?");
      this.modalService.openConfirm({
        message: message,
        okLabel: 'Continue'
      }).then(function () {
        return _this9.toggleUserRole(member.name, role);
      });
    }
    /* --- */
  }]);
  return OrgMemberList;
}();
module.exports = angular.module('backstage.components.orgs.view-org.member-list', ['backstage.services']).component('bsOrgMemberList', {
  templateUrl: '/src/angular/components/orgs/view-org/org-member-list/org-member-list.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgMemberList
}).name;